import React from 'react'
import {AppWrap, MotionWrap} from '../../wrapper'
import {motion} from 'framer-motion'
import './Offer.scss'
import {images} from '../../constants'

const Offer = () => {
    return (
        <>
            <div className="app__offer">
                    <motion.div

                        whileInView={{x: [-100, 0], opacity: [0, 1], root: ".app__offer"}}
                        transition={{duration: 0.5}}
                        className='app__offer-text'
                    >
                        <h2 className='head-text' style={{marginTop: 20}}>Vous souhaitez <span>augmenter</span> votre
                            <span> visibilité</span> sur les réseaux sociaux ?</h2>

                        <h2 className='head-text' style={{marginTop: 10}}><span>Comprendre</span> comment mettre en
                            place
                            une <span> routine efficace</span> ?</h2>

                        <h2 className='head-text' style={{marginTop: 10}}>Ou <span> simplement</span>,<br/> vous
                            préférez <span> déléguer</span> cette tâche,
                            pour vous concentrer sur <span>VOTRE activité</span> ?</h2>

                    </motion.div>
                <div className='app__offer-frame'>
                    <img src={images.iphone} alt="iphone-frame"/>
                    <div className="app__offer-video">
                        <video src={images.video} typeof='video/mp4' autoPlay={true} loop={true} preload='true'
                               muted={true} playsInline></video>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppWrap(
    MotionWrap(Offer, 'app__offer'),
    'offre',
    "app__whitebg"
)
